<template>
  <ul :class="{ 'menu-list': !isSubmenuList }">
    <p class="menu-label">{{ menu.title }}</p>
    <aside-menu-item
      v-for="(item, index) in menu.menu"
      :key="index"
      :item="item"
      @menu-click="menuClick(item)"
    />
  </ul>
</template>

<script>
import AsideMenuItem from '@/components/AsideMenuItem'

export default {
  name: 'AsideMenuList',
  components: {
    AsideMenuItem
  },
  props: {
    isSubmenuList: {
      type: Boolean,
      default: false
    },
    menu: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    menuClick (item) {
      this.$emit('menu-click', item)
    }
  }
}
</script>
